import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";
import { getItem } from "../../../utils/storageHelper";

// Action Types
export const REDO_SUCCESS = "REDO_SUCCESS";
export const REDO_ERROR = "REDO_ERROR";

// Thunk Action Creator
export const redo = createAsyncThunk(
    "api/Task/redo",
    async (_, { dispatch }) => {

        const firebaseData = await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`);
        const user = JSON.parse(firebaseData);

        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/redo`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        // Store tasks for offline access
                        idb.storeTaskList(response.data.tasks || response.data);
                    }                }
                else {
                    throw new Error("Error redoing task");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: REDO_SUCCESS,
                    payload: response.data
                });
            } else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: REDO_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
            //.then(response => {
            //    dispatch({
            //        type: REDO_SUCCESS,
            //        payload: response.data,
            //    });
            //})
            //.catch(error => {
            //    dispatch({ type: REDO_ERROR, payload: error });
            //});
        } catch (error) {
            dispatch({ type: REDO_ERROR, payload: error });
            await signOut();
        }
    }
);
